import EditCriterion from "./EditCriterion";
import React, {useEffect, useState} from "react";
import {StudyLayout} from "../StudyLayout";
import { Criterion, Group, Query} from "../../HealthcareUsageReport/types/CohortQuery";
import { Button, Row, Col } from "antd";
import { Project } from "../../../types/Project";
import buttonStyles from "../../../components/common/styled/Buttons.module.scss";
import {addCriterion, setCurrentQuery} from "../cohortBuilderSlice";
import {Routes} from "../../../pages/routes";
import {useAppDispatch, useAppSelector} from "../../../hooks";
import { generatePath, useRouteMatch, useHistory } from "react-router-dom";
import { StudyActions } from "../StudyActions";
import {getCurrent} from "../../../reducers/util";

const SaveButton = ({disabled, onSave}: {disabled: boolean, onSave: () => void}) => {
    return <Button
        className={`${buttonStyles["primary"]}`}
        type="primary"
        disabled={disabled}
        onClick={onSave}
    >
        Add
    </Button>

}

const CancelButton: React.FC<{study: Query, onCancel: (studyId: number) => void}> = ({study, onCancel}) => {
    return <Button className={`${buttonStyles["normal"]}`} onClick={() => onCancel(study.id)}>Cancel</Button>
}

export const EditCriteriaLayout: React.FC<{project: Project, study: Query}> = ({project, study}) => {
    const [criteriaReady, setCriteriaReady] = useState<boolean>(false)
    const [criterionUpdate, setCriterionUpdate] = useState<Criterion | undefined>();

    const { query, group, criterion } = useAppSelector(getCurrent) as { query: Query, group: Group, criterion: Criterion}

    const dispatch = useAppDispatch()
    const history = useHistory()
    const match = useRouteMatch(Routes.Project)

    const handleSend = () => {
        if (!criterionUpdate) {
            return;
        }

        const queryId = query.id
        const groupId = group.id
        dispatch(addCriterion({ queryId, groupId, criterion: criterionUpdate }))
        dispatch(setCurrentQuery(queryId))

        history.push(generatePath(Routes.Project, {
            ...match?.params,
            study: queryId > 0 ? 'study': undefined,
            studyId: queryId > 0 ? queryId : undefined,
            subpage: undefined
        }))

    };

    const onCancel = (queryId: number) => {
        dispatch(setCurrentQuery(queryId))
        history.push(generatePath(Routes.Project, {
            ...match?.params,
            study: queryId > 0 ? 'study': undefined,
            studyId: queryId > 0 ? queryId : undefined,
            subpage: undefined
        }))
    }

    useEffect(() => {
        setCriteriaReady(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [query.dataset])


    return <StudyLayout title={"Define Criteria"} floatSidebar={true}>
        <Row gutter={32}>
            <Col span={16}>
                <StudyActions
                    project={project}
                    study={study}
                    showDatasetPicker={false}
                    primaryAction={<SaveButton disabled={!criteriaReady || !criterionUpdate} onSave={handleSend}/>}
                    secondaryAction={<CancelButton study={study} onCancel={onCancel}/>}
                />
            </Col>
            <Col span={8}></Col>
        </Row>
        <EditCriterion
            query={query}
            criterion={criterionUpdate || criterion}
            onChange={(criterion) => setCriterionUpdate(criterion)}
            onFormReady={ready => setCriteriaReady(ready)}

        />

    </StudyLayout>
}